import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const DisconnectedHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2" className={classes.title}>
            Client Disconnected
          </Typography>
          <Typography variant="body1" className={classes.text}>
            This client has removed you as a practitioner. You can no longer
            access their historical data or any new data.
          </Typography>
        </>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default DisconnectedHelpIcon
